import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const contactDetails = [
  {
    icon: 'ri-phone-fill',
    label: 'Phone',
    value: '0483 944 617',
    href: 'tel:0483944617',
    desc: 'Monday – Friday, 9am – 5pm AEST',
  },
  {
    icon: 'ri-mail-fill',
    label: 'Email',
    value: 'rentals@galaxyhousing.com.au',
    href: 'mailto:rentals@galaxyhousing.com.au',
    desc: 'We reply within 1 business day',
  },
  {
    icon: 'ri-map-pin-fill',
    label: 'Postal Address',
    value: 'PO Box 1035, Spit Junction NSW 2088',
    href: undefined,
    desc: 'Serving regional areas and metro cities across Australia',
  },
  {
    icon: 'ri-facebook-fill',
    label: 'Facebook',
    value: 'facebook.com/GalaxyHousing',
    href: 'https://www.facebook.com/GalaxyHousing',
    desc: 'Follow us for updates and new listings',
  },
];

export default function ContactPage() {
  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative pt-24 pb-0 min-h-[48vh] flex items-end overflow-hidden">
          <div className="absolute inset-0 w-full h-full">
            <img
              src="https://readdy.ai/api/search-image?query=modern%20Australian%20property%20management%20office%20interior%2C%20professional%20business%20environment%2C%20clean%20white%20walls%2C%20natural%20light%2C%20minimalist%20desk%20setup%2C%20welcoming%20corporate%20space%2C%20contemporary%20design&width=1920&height=580&seq=contact-hero1&orientation=landscape"
              alt="Galaxy Housing contact us"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-navy-900/65 to-navy-950/90" />
          </div>
          <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pb-14">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-0.5 bg-gold-400" />
              <span className="text-gold-400 text-sm font-medium tracking-widest uppercase">Get In Touch</span>
            </div>
            <h1 className="font-heading text-5xl lg:text-6xl font-bold text-white leading-tight max-w-2xl">
              Contact Galaxy Housing
            </h1>
          </div>
        </section>

        {/* Main contact section */}
        <section className="py-20" style={{ background: 'rgb(246, 248, 252)' }}>
          <div className="max-w-4xl mx-auto px-6">
            <div className="text-center mb-12">
              <div className="flex items-center justify-center gap-3 mb-3">
                <div className="w-8 h-0.5 bg-gold-500" />
                <span className="text-gold-500 text-sm font-medium tracking-widest uppercase">Reach Us</span>
                <div className="w-8 h-0.5 bg-gold-500" />
              </div>
              <h2 className="font-heading text-4xl font-bold text-navy-800 mb-4">
                We&apos;d Love to Hear From You
              </h2>
              <p className="text-navy-700/65 text-base leading-relaxed max-w-xl mx-auto">
                Whether you&apos;re a prospective tenant searching for your next home or an existing tenant with a question — we&apos;re here to help.
              </p>
            </div>

            {/* Contact cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-10">
              {contactDetails.map((detail) => (
                <div key={detail.label} className="flex items-start gap-4 bg-white rounded-lg p-6 border border-navy-100">
                  <div className="w-11 h-11 flex items-center justify-center rounded-full bg-navy-800 text-gold-400 shrink-0">
                    <i className={`${detail.icon}`} />
                  </div>
                  <div>
                    <p className="text-navy-700/45 text-xs uppercase tracking-wide mb-1">{detail.label}</p>
                    {detail.href ? (
                      <a
                        href={detail.href}
                        target={detail.href.startsWith('http') ? '_blank' : undefined}
                        rel={detail.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                        className="font-semibold text-navy-800 text-sm hover:text-gold-500 transition-colors cursor-pointer break-all"
                      >
                        {detail.value}
                      </a>
                    ) : (
                      <p className="font-semibold text-navy-800 text-sm">{detail.value}</p>
                    )}
                    <p className="text-navy-700/50 text-xs mt-1">{detail.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Quick CTA */}
            <div className="bg-navy-900 rounded-lg p-8 text-center">
              <p className="font-heading font-bold text-white text-2xl mb-2">Looking for a Room?</p>
              <p className="text-white/60 text-sm mb-6 leading-snug max-w-sm mx-auto">Browse current vacancies across regional areas and metro cities on our dedicated rentals portal.</p>
              <a
                href="https://rentals.galaxyhousing.com.au"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-gold-500 hover:bg-gold-400 text-navy-900 font-semibold text-sm px-7 py-3 rounded transition-colors cursor-pointer whitespace-nowrap"
              >
                View Available Rentals
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-external-link-line" />
                </div>
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
